import React, { useState } from 'react';
import '../styles/Header.css';
import logo from '../assets/tact_logo.svg';

const Header = () => {
  const [activeLink, setActiveLink] = useState('Página Inicial');
  const [menuOpen, setMenuOpen] = useState(false); // controla menu mobile

  const handleClick = (name) => {
    setActiveLink(name);
    setMenuOpen(false); // fecha menu ao clicar
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      {/* Hamburger menu (mobile) */}
      <div className="hamburger" onClick={toggleMenu}>
        <span />
        <span />
        <span />
      </div>

      {/* Menu de links */}
      <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <a
          href="#features"
          className={`nav-button ${activeLink === 'Página Inicial' ? 'active' : ''}`}
          onClick={() => handleClick('Página Inicial')}
        >
          Página Inicial
        </a>
        <a
          href="#about"
          className={`nav-button ${activeLink === 'Sobre nós' ? 'active' : ''}`}
          onClick={() => handleClick('Sobre nós')}
        >
          Sobre nós
        </a>
        <a
          href="#plans"
          className={`nav-button ${activeLink === 'Plano e franquia' ? 'active' : ''}`}
          onClick={() => handleClick('Plano e franquia')}
        >
          Plano e franquia
        </a>
        <a
          href="#contact"
          className={`nav-button ${activeLink === 'Contato e suporte' ? 'active' : ''}`}
          onClick={() => handleClick('Contato e suporte')}
        >
          Contato e suporte
        </a>
      </nav>

      {/* Logo no canto direito */}
      <img src={logo} alt="Minha Landing Page" className="logo" />
    </header>
  );
};

export default Header;
